import fetch from "@web-noise/fetch";

export default async (
  url: string,
  audioContext: AudioContext,
): Promise<AudioBuffer> => {
  const response = await fetch(url);
  const arrayBuffer = await response.arrayBuffer();
  return audioContext.decodeAudioData(arrayBuffer);
};
